import { ServiceId, LegoContainerData } from 'lib/ecommerce/lego/Tc.Module.LegoContainer';

export function flavourSizeFromSiebelId(siebelId : string) {
	const idParts = siebelId.split(/\s+/);
	let size = idParts.pop();
	while (size && !size.match(/^([A-Z]+|Public|Private|light|go|premium|basic|flat)$/)) {
		size = idParts.pop();
	}
	if (!size) {
		return 'l';
	}
	const flavourSize = size.toLowerCase();

	return (flavourSize === 'private' || flavourSize === 'lego') ? 'l' : flavourSize;
}

export function parseLegoContainerDeeplink(
	deepLink : string,
	calcFlavourPrice : (serviceId : ServiceId, productId : string) => number,
) : LegoContainerData | null {
	if(!deepLink) {
		return null;
	}

	const [config, options] = deepLink.split('--');

	const deserialized : LegoContainerData = {
		config: [],
		options: {},
	};

	deserialized.config = config.split('__').map(serviceAndProductId => {
		const ids = serviceAndProductId.split('-') as ServiceId[];
		const serviceId = ids.shift() || '';
		const productId = ids.join('-');

		if (serviceId === '' || productId === '') {
			return undefined;
		}

		return {sliderId: serviceId, slideId: productId, cost: calcFlavourPrice(serviceId, productId)};
	}).filter(Boolean) as typeof deserialized.config;

	if(options) {
		deserialized.options = options.split('__').reduce((acc : any, option) => {
			const [key, value] = option.split('-');
			acc[key] = value;

			return acc;
		}, {});
	}

	return deserialized;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/generic/api/map.ts